// VerMultimedia.jsx
import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function VerMultimedia(props) {
	const { multimedia, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver multimedia" />
			<Offcanvas.Body>
				<h1>Datos del archivo multimedia</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{multimedia.id}</td>
								</tr>
								<tr>
									<th>Descripción</th>
									<td>{multimedia.descripcion}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{multimedia.orden}</td>
								</tr>
							</tbody>
						</Table>
						<div className="mt-4">
							<img
								src={process.env.REACT_APP_API_URL + 'uploads/' + multimedia.url}
								alt={multimedia.descripcion}
								className="img-fluid"
							/>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerMultimedia